module.exports = __webpack_public_path__ + "static/beersavorui-eb7c52e54e6954489a9b7c38279609fb.gif";